export default __webpack_public_path__ + "static/media/hero3.7e4ff36d.png";